export const MX_PLAN_TYPES_BASE_URL = `/api/v4/mx/subscriptions/`;

export const PET_DETAILS = {
  weight: '50',
  ideal_weight: '55',
  activity: 'moderate',
  neutered: false,
  allergies: ['id1', 'id2'],
};

export const PLAN_COMBINATIONS = [
  {
    combination_id: 'uuid',
    name: 'Combo Name',
    description: 'Combo Description',
    recipes: ['beef', 'chicken'],
    price: '50',
    subscription_price: {
      box_price: '300',
      price_per_week: '50',
    },
  },
  {
    combination_id: 'uuid2',
    name: 'Combo Name 2',
    description: 'Combo 2 Description',
    recipes: ['beef'],
    price: '50',
    subscription_price: {
      box_price: '300',
      price_per_week: '50',
    },
  },
];

export const makeRecommendedPlan = overrides => ({
  available_recipes: ['beef', 'chicken', 'turkey'],
  cadence: 2,
  plan_combinations: [
    {
      combination_id: 'UUID',
      name: 'Beef & Chicken Combo',
      weeks_of_food: 2,
      description: 'Enjoy two pupular recipes in a single box.',
      recipes: {
        fresh: ['beef', 'lamb'],
        baked: ['chicken'],
      },
      price: '24.99',
      discounted_price: '45.00',
      discounted_price_per_week: '22.50',
      subscription_data: {
        cadence: 2,
        box_price: '39.99',
        price_per_week: '9.99',
      },
    },
  ],
  metadata: {
    response_time: '2025-01-28T12:34:56Z',
    request_id: 'some-id',
  },
  ...overrides,
});

// this mimics the return data of useMxPlanCombosList
export const PLAN_COMBINATIONS_LIST = [
  makeRecommendedPlan(),
  makeRecommendedPlan({
    cadence: 4,
    plan_combinations: [
      {
        combination_id: 'UUID',
        name: 'Beef & Chicken Combo',
        weeks_of_food: 4,
        description: 'Enjoy two pupular recipes in a single box.',
        recipes: {
          fresh: ['beef', 'lamb'],
          baked: ['chicken'],
        },
        price: '24.99',
        discounted_price: '45.00',
        discounted_price_per_week: '22.50',
        subscription_data: {
          cadence: 4,
          box_price: '39.99',
          price_per_week: '9.99',
        },
      },
    ],
  }),
  makeRecommendedPlan({
    cadence: 6,
    plan_combinations: [
      {
        combination_id: 'UUID',
        name: 'Beef & Chicken Combo',
        weeks_of_food: 6,
        description: 'Enjoy two pupular recipes in a single box.',
        recipes: {
          fresh: ['beef', 'lamb'],
          baked: ['chicken'],
        },
        price: '24.99',
        discounted_price: '45.00',
        discounted_price_per_week: '22.50',
        subscription_data: {
          cadence: 6,
          box_price: '39.99',
          price_per_week: '9.99',
        },
      },
    ],
  }),
];

export const SUBSCRIPTION_ID = '123';

export const INVALID_SUBSCRIPTION_ERROR_MESSAGE = 'Cannot find subscrtiption';
export const NO_MEAL_PLANS_FOUND_ERROR_MESSAGE =
  'No meal plans found for this pet';
export const FIELD_IS_REQUIRED_ERROR_MESSAGE = 'Field is required';

export const RECIPES_STANDARD_FORMAT = {
  chicken: 'Chicken dish with carrots',
  beef: 'Beef dish with sweet potatoes',
  pork: 'Pork dish with apples',
  turkey: 'Turkey dish with blueberries',
  lamb: 'Lamb dish with cranberries',
};

export const RECIPES_UPPERCASE_FORMAT = {
  chicken: 'Chicken Dish with Carrots',
  lamb: 'Lamb Dish with Cranberries',
  beef: 'Beef Dish with Sweet Potatoes',
  pork: 'Pork Dish with Apples',
  turkey: 'Turkey Dish with Blueberries',
};
